const API_BASE_URL = "https://adminmatrimony.gudstart.com/api";

// const API_BASE_URL = "http://localhost/matrimony_admin";

const apiEndpoints = {
  register: `${API_BASE_URL}/register.php`,
  adminLogin: `${API_BASE_URL}/admin_actions.php`,
  validateToken: `${API_BASE_URL}/jwtautogenerate.php`,
  getOptions: `${API_BASE_URL}/get_options.php`,
  userDetails: `${API_BASE_URL}/user_details.php`,
  approveUser: `${API_BASE_URL}/user_approve.php`,
  enquiries: `${API_BASE_URL}/enquiry_admin.php`,
  reports: `${API_BASE_URL}/report.php`,
  adminCrud: `${API_BASE_URL}/admin_crud.php`,
  count: `${API_BASE_URL}/countapi.php`,
  permission: `${API_BASE_URL}/permission.php`,
  subscriptionPlans: `${API_BASE_URL}/subscription_plans.php`,
  payments: `${API_BASE_URL}/payments_api.php`,
  image: `${API_BASE_URL}/`,
};

export default apiEndpoints;
